import { action } from 'satcheljs';

export interface FlexPaneClosedActionMessage {
    flexPaneId: string;
}
const flexPaneClosed: (flexPaneId: string) => FlexPaneClosedActionMessage = action(
    'flexPaneClosed',
    (flexPaneId: string): FlexPaneClosedActionMessage => ({
        flexPaneId,
    })
);

export default flexPaneClosed;
